export default __webpack_public_path__ + "static/bentoSectionBg2-1636ca68111ef366a10b21ac7bb3dbc2.webp";